<template>
	<div>
		<!-- pc 端 -->
		<div
			v-if="terminal == 0"
			class="vaM_E"
			:class="{ flexW: ipts.length > 1 }"
		>
			<div
				v-show="ipts.length > 1"
				class="w100pct mt3x mb1x bdSplitLine-top bd-dashed-top pt205x fsLv3"
			>
				{{ getLanguageStr("word1502", "输入项") }}
			</div>
			<div
				v-for="(ipt, index) in ipts"
				:key="index"
				:class="{ 'pt1x pb1x w33pct mb05x': ipts.length > 1 }"
			>
				<section v-if="ipt.type == 'none'"></section>
				<section
					v-else-if="ipt.type == 'input'"
					class="flexW pl1x_E aiC"
				>
					<div
						v-if="!ipt.lock"
						class="w30pct cSub textCut"
						:class="ipts.length == 1 ? 'taR' : 'w100pct mb05x '"
						:title="
							ipts.length > 1
								? ipt.name
								: getLanguageStr('word1502+: ', '输入项: ')
						"
					>
						{{
							ipts.length > 1
								? ipt.name
								: getLanguageStr("word1502+: ", "输入项: ")
						}}
					</div>
					<div
						class="flexW aiC"
						:class="{ 'pr30pct w100pct': ipts.length > 1 }"
					>
						<div class="flex100">
							<InputText
								v-if="!ipt.lock"
								v-model="ipt.value"
								class="w100pct"
								:name="code + '-' + codeGroup + '-' + index"
								:placeholder="ipt.input.placeholder"
								verify-method=""
								:is-error="ipt.input.inputErr.isError"
								:error-tip="ipt.input.inputErr.errorTip"
								:only="ipt.input.rule.only"
								:match-type="ipt.input.rule.matchType"
								:max-length="ipt.input.maxLength"
								@Focus="inputFocus(index)"
								@Blur="
									v => {
										inputBlur(index, v);
									}
								"
							></InputText>
							<div v-else class="cError">
								{{
									$t("device404", [
										getOrderLanguage(ipt.lockingText[0]),
										"请先XX"
									])
								}}
							</div>
						</div>
						<div v-if="!ipt.lock" class="w8x pl1x">
							{{ getOrderLanguage(ipt.input.unit[0]) }}
						</div>
					</div>
				</section>
				<section
					v-else-if="ipt.type == 'select'"
					class="flexW pl1x_E aiC"
				>
					<div
						v-if="!ipt.lock"
						class="w30pct cSub textCut"
						:class="ipts.length == 1 ? 'taR' : 'w100pct mb05x '"
						:title="ipts.length > 1 ? ipt.name : ''"
					>
						{{ ipts.length > 1 ? ipt.name : "" }}
					</div>
					<div
						class="flexW aiC"
						:class="{ 'pr30pct w100pct': ipts.length > 1 }"
					>
						<Select
							v-model="ipt.value"
							:bind-active="ipt.value"
							:list="ipt.select"
							:name="code + '-' + codeGroup + '-' + index"
						></Select>
					</div>
				</section>
				<vue-datepicker-local
					v-else-if="ipt.type == 'time'"
					v-model="ipt.value"
					class="datepicker"
					:name="code + '-' + codeGroup + '-' + index"
					:format="ipt.format"
					:area="
						ipt.area
							? [
									new Date(ipt.area[0]).getTime(),
									new Date(ipt.area[1]).getTime()
							  ]
							: null
					"
				></vue-datepicker-local>
				<section v-else-if="ipt.type == 'hm'">
					<Select v-model="ipt.valueH" :list="timeH"></Select>
					<Select v-model="ipt.valueM" :list="timeM"></Select>
				</section>
				<section v-else-if="ipt.type == 'hms'">
					<Select v-model="ipt.valueH" :list="timeH"></Select>
					<Select v-model="ipt.valueM" :list="timeM"></Select>
					<Select v-model="ipt.valueS" :list="timeS"></Select>
				</section>
				<section v-else-if="ipt.type == 'datehms'" class="vaM_E">
					<vue-datepicker-local
						v-model="ipt.value"
						class="datepicker"
						:format="'YYYY/MM/DD'"
					></vue-datepicker-local>
					<Select v-model="ipt.valueH" :list="timeH"></Select>
					<Select v-model="ipt.valueM" :list="timeM"></Select>
					<Select v-model="ipt.valueS" :list="timeS"></Select>
				</section>
			</div>
		</div>
		<!-- 手机端 -->
		<div v-else class="vaM_E">
			<div
				v-if="ipts.length > 1"
				class="bdSplitLine-bottom fsLv4-mobile pb2x pt5x"
			>
				{{ getLanguageStr("word1502", "输入项") }}
			</div>
			<div
				v-for="(ipt, index) in ipts"
				:key="index"
				:class="{ 'pt1x pb1x': ipts.length > 1 }"
			>
				<section v-if="ipt.type == 'none'"></section>
				<section v-else-if="ipt.type == 'input'" class="mt2x">
					<div v-if="!ipt.lock">
						<p class="fsLv2 fsLv4-mobile">
							{{
								ipts.length > 1
									? ipt.name
									: getLanguageStr("word1502", "输入项")
							}}
						</p>
						<!-- {{ ipts.length > 1 ? ipt.name : getLanguageStr("word1502+: ", "输入项: ") }} -->
					</div>
					<!-- ipts.input.unit[1] -->
					<div class="mt1x">
						<InputText
							v-if="!ipt.lock"
							v-model="ipt.value"
							class="w100pct"
							:name="code + '-' + codeGroup + '-' + index"
							:placeholder="ipt.input.placeholder"
							verify-method=""
							:unit="getOrderLanguage(ipt.input.unit[0], '单位')"
							:is-error="ipt.input.inputErr.isError"
							:error-tip="ipt.input.inputErr.errorTip"
							:only="ipt.input.rule.only"
							:match-type="ipt.input.rule.matchType"
							:max-length="ipt.input.maxLength"
							@Focus="inputFocus(index)"
							@Blur="
								v => {
									inputBlur(index, v);
								}
							"
						/>
						<div v-else class="cError">
							{{
								$t("device404", [
									getOrderLanguage(ipt.lockingText[0]),
									"请先XX"
								])
							}}
						</div>
					</div>
					<!-- <div v-if="!ipt.lock" class="w6x">{{ getOrderLanguage(ipt.input.unit[0]) }}</div> -->
				</section>
				<!-- <Select v-else-if="ipt.type == 'select'" v-model="ipt.value" :bindActive="ipt.value" :list="ipt.select"></Select> -->
				<section v-else-if="ipt.type == 'select'" class="mt2x">
					<p class="fsLv2 fsLv4-mobile">
						{{
							ipts.length > 1
								? ipt.name
								: getLanguageStr("word1502", "输入项")
						}}
					</p>
					<div>
						<div
							class="w100pct h405x boxR selectBox posR pt2x pb1x"
							@click="selectInputPopup(index)"
						>
							<span class="text flex100 fsField">{{
								_get(
									ipt,
									["selectPopInput", "showText"],
									false
								) || getLanguageStr("word806", "请选择")
							}}</span>
							<span class="moreB"
								><van-icon name="play" class="s-more"
							/></span>
						</div>
						<van-popup
							v-model="ipt.showInputPop"
							position="bottom"
							class="popupStyle"
							duration="0.3"
							:get-container="'body'"
							:close-on-click-overlay="false"
						>
							<div class="h100pct w100pct posR">
								<div
									ref="popupHeader"
									class="pt2x flexW jcSb aiC pb105x bdSplitLine-bottom popupHeader bgContent w100pct"
								>
									<div
										class="cSub ml2x"
										@click="cancelInputPop(index)"
									>
										{{ getLanguageStr("cmd85", "取消") }}
									</div>
									<div class="fsLv3 fsLv6-mobile">
										{{
											getLanguageStr("word1502", "输入项")
										}}
									</div>
									<div
										class="cMain mr2x"
										@click="confirmInputPop(index)"
									>
										{{ getLanguageStr("cmd12", "确定") }}
									</div>
								</div>
								<div class="pt7x ml2x mr2x">
									<div
										v-for="(input, idx) of ipt.select.slice(
											1
										)"
										:key="idx"
										class="bdSplitLine-bottom pt105x pb105x flexW aiC w100pct"
										@click="selectMobileInput(input, index)"
									>
										<div
											class="flex100"
											:class="{
												cMain:
													_get(
														ipt,
														[
															'selectPopInput',
															'code'
														],
														false
													) === input['text']
											}"
										>
											{{
												typeof input.text == "string"
													? input.text
													: input.text[1]
											}}
										</div>
										<Icon
											v-show="
												_get(
													ipt,
													['selectPopInput', 'code'],
													false
												) ===
													(typeof input.text ==
													'string'
														? input.text
														: input.text[0])
											"
											name="yes"
											:type="'svg'"
											:class="{
												fMain:
													_get(
														ipt,
														[
															'selectPopInput',
															'code'
														],
														false
													) ===
													(typeof input.text ==
													'string'
														? input.text
														: input.text[0])
											}"
											class="w205x h205x mr2x"
										></Icon>
									</div>
								</div>
							</div>
						</van-popup>
					</div>
				</section>
				<section
					v-else-if="ipt.type === 'time' || ipt.type === 'hm'"
					class="mt2x"
				>
					<div
						class="w100pct h405x boxR selectBox posR pt1x pb1x flexW jcSb aiC"
						@click="selectDate(cmd)"
					>
						<span class="text flex100 fsField">{{
							cmd.selectedText ||
								getOrderLanguage("word806", "请选择")
						}}</span>
						<span class="moreB"
							><van-icon name="play" class="s-more"
						/></span>
					</div>
					<van-popup
						v-model="cmd.selcetPopup"
						position="bottom"
						class="popupStyle"
						:get-container="'body'"
					>
						<div
							class="pt2x flexW jcSb aiC pb105x bdSplitLine-bottom popupHeader bgContent w100pct"
						>
							<div class="cSub ml2x" @click="dateCancel">
								{{ getOrderLanguage("cmd85", "取消") }}
							</div>
							<div class="fsLv3 fsLv6-mobile">
								{{ getOrderLanguage("device131", "操作时间") }}
							</div>
							<div class="cMain mr2x" @click="dateYes">
								{{ getOrderLanguage("cmd12", "确定") }}
							</div>
						</div>
						<van-datetime-picker
							ref="date"
							v-model="cmd.value"
							:type="ipt.type === 'time' ? 'datetime' : 'time'"
							class="pt7x"
							:show-toolbar="false"
							:min-date="minDate"
							:max-date="maxDate"
							@confirm="value => dateConfirm(value, ipt)"
						/>
					</van-popup>
				</section>
			</div>
		</div>
	</div>
</template>

<script>
import * as lib from '@/util/lib'
import * as orderConfig from '@/util/deviceOrderConfig'
import specialCheckFn from '@/util/rule.js'
import { getLanguageStr } from '@/util/language'
import Vue from 'vue'
import { DatetimePicker } from 'vant'

import InputText from '@/components/common/ui/InputText'
import Select from '@/components/common/ui/Select.vue'

import { getIn, setIn } from '@/util/manipulate'
Vue.use(DatetimePicker)

export default {
  name: 'OrderInput',
  props: {},
  components: { InputText, Select },
  data () {
    return {
      code: '',
      codeGroup: '',
      ipts: [],
      timeH: (() => {
        const list = Array(24)
          .fill()
          .map((_, i) => ({
            value: i.toString().padStart(2, '0'),
            text: i.toString().padStart(2, '0')
          }))
        list.unshift({
          value: '',
          text: getLanguageStr('word806', '请选择'),
          token: true
        })
        return list
      })(),
      timeM: (() => {
        const list = Array(60)
          .fill()
          .map((_, i) => ({
            value: i.toString().padStart(2, '0'),
            text: i.toString().padStart(2, '0')
          }))
        list.unshift({
          value: '',
          text: getLanguageStr('word806', '请选择'),
          token: true
        })
        return list
      })(),
      timeS: (() => {
        const list = Array(60)
          .fill()
          .map((_, i) => ({
            value: i.toString().padStart(2, '0'),
            text: i.toString().padStart(2, '0')
          }))
        list.unshift({
          value: '',
          text: getLanguageStr('word806', '请选择'),
          token: true
        })
        return list
      })(),
      showInputPop: false, // 输入项pop展示
      selectPopInput: {}, // 输入项pop中，选中的输入项
      mobileInputList: [], // 下拉框
      cmd: {
        area: null,
        value: null,
        selcetPopup: false,
        selectedText: ''
      },
      minDate: new Date(),
      maxDate: new Date()
    }
  },
  methods: {
    getLanguageStr,
    getOrderLanguage: orderConfig.getLanguage,
    timeFormat: lib.timeFormat,
    _get: _.get,
    getIn,
    setIn,
    async init (ipt, code, cg) {
      this.code = code
      this.codeGroup = cg
	  this.ipts = []
	  this.$nextTick(() => {
        const that = this
        if (ipt && ipt.length) {
          let list = _.cloneDeep(ipt)
          $.each(list, (index, val) => {
            val.name = orderConfig.getLanguage(
              typeof val.name === 'string' ? val.name : val.name[0]
            )
            if (val.select) {
              val.select = orderConfig.getLanguageList(val.select)
            }
            if (val.type == 'time') {
              val.value = new Date()
            }
            if (val.type == 'hm') {
            // val.value = new Date();
            }
          })
          that.ipts = list
          if (that.ipts.length) {
            if (that.ipts[0].area && that.ipts[0].area.length) {
              that.cmd.value = new Date()
              that.cmd.selectedText = mz(+new Date()).format(
                'YYYY/MM/DD HH:mm'
              )
              that.cmd.area = [
                new Date(that.ipts[0].area[0]).getTime(),
                new Date(that.ipts[0].area[1]).getTime()
              ]
            }
          }
        } else that.ipts = []
	  })
    },
    inputFocus (index) {
      this.ipts[index].input.inputErr.isError.error = true
      this.ipts[index].input.inputErr.errorTip =
				this.ipts[index].input.inputTips &&
				$.type(this.ipts[index].input.inputTips) == 'array'
				  ? orderConfig.getLanguage(
				    this.ipts[index].input.inputTips[0]
					  )
				  : this.ipts[index].input.inputTips || ''
    },
    inputBlur (index, value) {
      const that = this
      // 不需要校验值的逻辑
      if (
        that.getIn(
          that.ipts[index],
          ['input', 'rule', 'notCheckVal'],
          false
        ) &&
				that.ipts[index].input.rule['notCheckVal'].includes(value + '')
      ) {
        that.ipts[index].input.inputErr.isError.error = false
        that.ipts[index].input.inputErr.errorTip = ''
        return
      }
      // 特殊规则校验
      if (
        that.getIn(
          that.ipts[index],
          ['input', 'rule', 'checkFnName'],
          false
        ) &&
				specialCheckFn[that.ipts[index].input.rule.checkFnName]
      ) {
        const checkFnName = that.ipts[index].input.rule.checkFnName
        const checkFnParams =
					that.getIn(
					  that.ipts[index],
					  ['input', 'rule', 'checkFnParams'],
					  false
					) || []
        const result = specialCheckFn[checkFnName](
          value,
          ...checkFnParams
        )
        that.ipts[index].input.inputErr.isError.error = !result
        result && (that.ipts[index].input.inputErr.errorTip = '')
        if (!result) return
      }
      let matchArea = false // that.ipts[index].value
      if (that.ipts[index].input.rule.areas) {
        // 输入区间的判断
        that.ipts[index].input.rule.areas.map(item => {
          if (Number(value) >= item[0] && Number(value) <= item[1]) {
            matchArea = true
          }
        })
      } else if (that.ipts[index].input.rule.regular) {
        if (
          lib.validValue(value, [that.ipts[index].input.rule.regular])
            .allClear
        ) {
          matchArea = true
        }
      } else {
        // 没有设置，作为无需校验
        matchArea = true
      }
      if (value === '' || matchArea) {
        that.ipts[index].input.inputErr.isError.error = false
        that.ipts[index].input.inputErr.errorTip = ''
      }
      if (stage.browser.ios) {
        $('html,body').animate(
          { scrollTop: $('body').offset().top },
          0
        )
      }
    },
    orderInputCheck () {
      let cr = true
      this.ipts.map(ipt => {
        if (cr) {
          switch (ipt.type) {
            case 'input':
              if (ipt.input.inputErr.isError.error) {
                cr = false
                this.$notify(
                  ipt.name +
										' ' +
										getLanguageStr(
										  'command12',
										  '输入项有误'
										),
                  { className: 'mTips' }
                )
              } else if (ipt.value === '') {
                cr = false
                this.$notify(
                  ipt.name +
										' ' +
										getLanguageStr(
										  'command13',
										  '输入项不能为空'
										),
                  { className: 'mTips' }
                )
              }
              break
            case 'select':
              if (
                ipt.value === '' ||
								ipt.value == undefined ||
								ipt.value == null
              ) {
                this.$notify(
                  getLanguageStr(
                    'device413',
                    '请完善指令内容'
                  ),
                  { className: 'mTips' }
                )
                cr = false
              }
              break
            case 'date':
              if (ipt.value == '') {
                this.$notify(
                  getLanguageStr('word806', '请选择') +
										ipt.name,
                  { className: 'mTips' }
                )
                cr = false
              }
              break
            case 'month':
              if (ipt.value == '') {
                this.$notify(
                  getLanguageStr('word806', '请选择') +
										ipt.name
                )
                cr = false
              }
              break
            case 'hm':
              if (this.terminal === 0) {
                if (!ipt.valueH || !ipt.valueM) {
                  this.$notify(
                    getLanguageStr('word806', '请选择') +
											ipt.name
                  )
                  cr = false
                }
              } else {
                if (!ipt.value) {
                  this.$notify(
                    getLanguageStr('word806', '请选择') +
											ipt.name
                  )
                  cr = false
                }
              }
              break
            case 'hms':
              if (!ipt.valueH || !ipt.valueM || !ipt.valueS) {
                this.$notify(
                  getLanguageStr('word806', '请选择') +
										ipt.name
                )
                cr = false
              }
              break
            case 'datehms':
              if (
                !ipt.value ||
								!ipt.valueH ||
								!ipt.valueM ||
								!ipt.valueS
              ) {
                this.$notify(
                  getLanguageStr('word806', '请选择') +
										ipt.name
                )
                cr = false
              }
              break
            default:
              break
          }
          if (cr && Number(this.orderTimeout) == 0) {
            this.$notify(
              getLanguageStr('phrase847', '请输入超时时间')
            )
            cr = false
          }
        }
      })
      return cr
    },
    getOrderInputValue () {
      if (this.orderInputCheck()) {
        return this.ipts
      } else {
        return false
      }
    },
    // 输入项pop打开
    selectInputPopup (i) {
      // this.showInputPop = true;
      this.$set(this.ipts[i], 'showInputPop', true)
      // this.ipts[0].value = "";
      this.init(this.ipts)
    },
    // 取消输入项pop弹窗
    cancelInputPop (i) {
      // this.showInputPop = false;
      this.$set(this.ipts[i], 'showInputPop', false)
      // this.selectPopInput = {};
      this.$set(this.ipts[i], 'selectPopInput', {})
      // this.ipts[0].value = "";
      this.init(this.ipts)
    },
    confirmInputPop (i) {
      // this.showInputPop = false;
      this.$set(this.ipts[i], 'showInputPop', false)
      let obj = this.mobileInputList.find(
        input => input.text['0'] == this.ipts[i].selectPopInput.code
      )
      // this.ipts[i].selectPopInput = { ...this.ipts[i].selectPopInput, ...obj };
      this.$set(this.ipts[i], 'selectPopInput', {
        ...this.ipts[i].selectPopInput,
        ...obj
      })
      this.ipts[i].value = this.ipts[i].selectPopInput.value
      this.init(this.ipts)
    },
    selectMobileInput (input, i) {
      this.$set(this.ipts[i], 'selectPopInput', {
        ...this.ipts[i].selectPopInput,
        code:
					typeof input.text === 'string' ? input.text : input.text[0],
        showText:
					typeof input.text === 'string' ? input.text : input.text[1],
        value: input.value
      })
    },
    selectDate (cmd) {
      this.minDate = this.timeArea(cmd.area)[0]
      this.maxDate = this.timeArea(cmd.area)[1]
      this.$set(cmd, 'selcetPopup', true)
    },
    timeArea (area) {
      if (area) {
        const start = new Date(area[0])
        const end = new Date(area[1])
        return [start, end]
      }
      return [undefined, undefined]
    },
    dateYes () {
      this.$refs.date[0].getPicker().confirm()
      this.$set(this.cmd, 'selcetPopup', false)
    },
    dateCancel () {
      this.$set(this.cmd, 'selcetPopup', false)
    },
    dateConfirm (value, ipt) {
      if (ipt.type === 'time') {
        this.$set(
          this.cmd,
          'selectedText',
          mz(value).format('YYYY/MM/DD HH:mm')
        )
      } else if (ipt.type === 'hm') {
        this.$set(this.cmd, 'selectedText', value)
        this.$set(ipt, 'value', value)
      } else {
        this.$set(this.cmd, 'selectedText', '')
      }
    }
  },
  computed: {
    // getConfigOptionI18nList:function(){
    // 	return this.ipts?orderConfig.getLanguageList(this.ipts.select||[]):[];
    // }
  },
  created () {
    this.terminal = stage.browser.mobile ? 1 : 0
  },
  mounted () {}
}
</script>

<style lang="scss" scoped>
.datepicker {
	width: 15em;
	height: 2.5em;
	line-height: 2.5em;
}
.errorTip,
.infoTip {
	padding: 0.1em 0.5em 0 0.5em;
	opacity: 1;
	&.errorTip-right {
		line-height: 2;
	}
	&.errorTip-static {
		padding: {
			top: 0.3em;
		}
		position: relative;
		text-align: left;
	}
}

.selectBox {
	padding-right: 3.2vmin;
	padding-left: 3.2vmin;
	background-color: #f3f3f6;
}
.moreB {
	position: absolute;
	top: 50%;
	right: 3.2vmin;
	transform: translate(0, -50%);
}
.s-more {
	transform: rotate(90deg);
}
.popupStyle {
	max-height: 76%;
	// overflow: hidden;
	border-radius: 3.2vmin 3.2vmin 0 0;
}
.popupHeader {
	position: fixed;
	// top: 0;
	left: 0;
	z-index: 10;
	border-radius: 3.2vmin 3.2vmin 0 0;
}
</style>
<style lang="scss">
.mTips {
	.van-dialog__message {
		font-size: 16px;
	}
}
</style>



// WEBPACK FOOTER //
// src/view/device/device/part/OrderInput.vue